import { Injectable , Output, EventEmitter} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { environment } from '../../../environments/environment';
import { AuthenticationService } from "../../views/authentication/authentication.service";

@Injectable()
export class OptimizationGraphService {

  @Output() filterData: EventEmitter<any> = new EventEmitter();
  @Output() selectedFilter: any = {};

  public settings: any = {isDraggable: false};
  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  setFilterData(filter){
    this.selectedFilter = filter;
    this.filterData.emit(filter);
  }

  public getCarriersLabels(): Observable<any>  {
    return this.http.get(environment.API + '/carriers-labels/', { headers: this.getHeaders() });
  }

  public getUserPreferences(): Observable<any>  {
    return this.http.get(environment.API + '/user/preferences/', { headers: this.getHeaders() });
  }
  public setUserPreferences(data: any): Observable<any>  {
    return this.http.post(environment.API + '/user/preferences/', data, { headers: this.getHeaders() });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/optimization-graph/optimization-graph.service.ts